import { BoardTypeInterface } from '@vatos-pas/common';
import { BoardDto } from './types';

export type LaborOnlyLoadoutEntry = {
  floor: number;
  boardTypeShortName: string;
};

// Fixed Labor Only Loadout for every builder, subdivision, and model.
// Board types are matched by exact short name at run time.
export const LABOR_ONLY_LOADOUT: readonly LaborOnlyLoadoutEntry[] = [
  { floor: 1, boardTypeShortName: 'LO Regular' },
  { floor: 1, boardTypeShortName: 'LO Dense' },
  { floor: 1, boardTypeShortName: 'LO 5/8 Type X' },
  { floor: 1, boardTypeShortName: 'LO Soffit' },
  { floor: 2, boardTypeShortName: 'LO Regular' },
  { floor: 2, boardTypeShortName: 'LO Dense' },
];

export const LABOR_ONLY_ON_DIALOG_TITLE =
  'Are you sure you want to enable Labor Only? The boards will be replaced with the standard Labor Only Loadout and all materials will be removed from the PO';

export const LABOR_ONLY_OFF_DIALOG_TITLE =
  'Are you sure you want change the labor only? This will remove all boards and materials from the PO';

export const LABOR_ONLY_LOADOUT_ERROR_MESSAGE =
  'Failed to load the Labor Only board types. Please add the boards manually.';

export const getLaborOnlyLoadoutPartialWarning = (
  missingShortNames: string[],
): string =>
  `Some Labor Only Loadout board types were not found: ${missingShortNames.join(
    ', ',
  )}. Please add the missing boards manually.`;

export type LaborOnlyLoadoutBoardType = Pick<
  BoardTypeInterface,
  'id' | 'shortName'
>;

export type LaborOnlyLoadoutResult = {
  lines: BoardDto[];
  missingShortNames: string[];
};

export const buildLaborOnlyLoadout = (
  boardTypes: LaborOnlyLoadoutBoardType[],
): LaborOnlyLoadoutResult => {
  const idByShortName = new Map(
    boardTypes.map(boardType => [boardType.shortName, boardType.id]),
  );

  const lines: BoardDto[] = [];
  const missingShortNames: string[] = [];

  LABOR_ONLY_LOADOUT.forEach(({ floor, boardTypeShortName }) => {
    const boardTypeId = idByShortName.get(boardTypeShortName);

    if (boardTypeId) {
      lines.push({ floor, boardTypeId, quantity: 0 });
    } else if (!missingShortNames.includes(boardTypeShortName)) {
      missingShortNames.push(boardTypeShortName);
    }
  });

  return { lines, missingShortNames };
};
